export type ApiErrorBody = { code: string; message: string; details?: unknown };

export class ApiError extends Error {
  status: number;
  code: string;
  details?: unknown;
  constructor(status: number, body: ApiErrorBody) {
    super(body.message);
    this.status = status;
    this.code = body.code;
    this.details = body.details;
  }
}

export const parseApiError = async (res: Response): Promise<ApiError> => {
  const json = (await res.json().catch(() => null)) as { error?: ApiErrorBody } | null;
  return new ApiError(res.status, json?.error ?? { code: 'UNKNOWN', message: res.statusText });
};
